import { Box, Heading, TextBlock } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./value-step-card.scss";

interface Props {
    currentStepNumber: number;
    heading: React.ReactNode;
    description: React.ReactNode;
    leftSectionContent: React.ReactNode;
    rightSectionContent: React.ReactNode;
}

export const ValueStepCard = (props: Props) => {
    const { t } = useTranslation();

    return (
        <Box className={style.stepContentWrapper}>
            <Box className={style.leftSectionContentWrapper}>{props.leftSectionContent}</Box>
            <Box columnLayout justifyContent={"SpaceBetween"} gap={"Xs"} className={style.rightSectionContentWrapper}>
                <TextBlock disableBottomSpacing className={style.stepCounter}>
                    {t("AssetManagement.value.stepCounter", {
                        current: props.currentStepNumber,
                        total: 4,
                    })}
                </TextBlock>

                <Box columnLayout gap="Xs">
                    <Heading variant="h1" disableTopSpacing disableBottomSpacing className={style.extraBold}>
                        {props.heading}
                    </Heading>
                    <TextBlock className={style.description} disableBottomSpacing>
                        {props.description}
                    </TextBlock>
                </Box>
                {props.rightSectionContent}
            </Box>
        </Box>
    );
};
